import { buildFilterString } from '@/lib/api/common/items';
import type { ParsedInsightsFilters } from '@/lib/api/types/insights/filters';
import { and, equals, or } from '@/lib/utils/common/rsqlFilters';
import { buildCommonFilters } from './buildItemFilter';

const buildScopeItemFilterString = (scopeItemId?: number): string | undefined => {
  if (!scopeItemId) return undefined;

  return or(equals('ancestor.id', String(scopeItemId)), equals('id', String(scopeItemId)));
};

export const buildInsightsApiFilter = (
  filters: ParsedInsightsFilters,
  scopeItemId?: number,
  loopId?: number,
): string | undefined => {
  const itemFilters = buildCommonFilters(filters);
  const itemFiltersString = buildFilterString(itemFilters);
  const scopeItemFilterString = buildScopeItemFilterString(scopeItemId);
  const loopIdFilterString = loopId ? equals('loopId', String(loopId)) : undefined;

  const parts = [loopIdFilterString, scopeItemFilterString, itemFiltersString].filter(
    Boolean,
  ) as string[];

  if (parts.length === 0) return undefined;
  if (parts.length === 1) return parts[0];
  return and(...parts);
};
